import GoogleChartContainer from '../../../Componant/Charts/GoogleChart/GoogleChart'

const GoogleChart = () => {
  return (
    <div className='page-body'>
      <GoogleChartContainer />
    </div>
  )
}

export default GoogleChart